import { type IUserProfile } from '@inpart-io/devtools-iap';
import { RECEIVE_DATA_OBJECTS, REMOVE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type MutationTree } from 'vuex';

import { type IUserProfileState } from './types';

export const mutations: MutationTree<IUserProfileState> = {
    [RECEIVE_DATA_OBJECTS](_state: IUserProfileState, { dataObjectList }: { dataObjectList: IUserProfile[] }) {
        for (const dataObject of dataObjectList) {
            _state.dataObjectList.set(dataObject.dobjId, Object.assign({}, _state.dataObjectList.get(dataObject.dobjId), dataObject));
            if (dataObject.user !== null && dataObject.user !== undefined) {
                if (dataObject.user instanceof Object) {
                    _state.byUser.set(dataObject.user.dobjId, dataObject.dobjId);
                } else {
                    _state.byUser.set(dataObject.user, dataObject.dobjId);
                }
            }
        }
    },

    [REMOVE_DATA_OBJECTS](_state: IUserProfileState, { dobjId }: { dobjId: number }) {
        if (_state.dataObjectList.has(dobjId)) {
            const userProfile = _state.dataObjectList.get(dobjId);
            if (userProfile.user instanceof Object) {
                _state.byUser.delete(userProfile.user.dobjId);
            } else {
                _state.byUser.delete(userProfile.user);
            }
        }
        _state.dataObjectList.delete(dobjId);
    }
};
